import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import Clappr from 'clappr';
@Component({
  selector: 'app-detail-page',
  templateUrl: './detail-page.component.html',
  styleUrls: ['./detail-page.component.scss']
})
export class DetailPageComponent implements OnInit, AfterViewInit, OnDestroy {

  user;
  player: any;
  extra = true;
     constructor(private router: Router, private http: HttpClient, private viewportScroller: ViewportScroller,private route: ActivatedRoute,) { }
 

  ngOnInit(): void {
       this.user = JSON.parse(localStorage.getItem('clpUser'));
    if (localStorage.getItem("clpUser") != null) {
      this.extra = false;

    }  }
  // player: any;


ngAfterViewInit() {
this.player = new Clappr.Player({
source: 'https://partner-connekktmedia.akamaized.net/prod/697a0442ed88f_Connekkt_Revised_1/master.m3u8',
parentId: '#player',
autoPlay: false,
mute: false,
height: '100%',
width: '100%',
});
this.route.fragment.subscribe(fragment => {
if (fragment) {
setTimeout(() => {
this.viewportScroller.scrollToAnchor(fragment);
}, 300);
}
});
}


ngOnDestroy() {
if (this.player) {
this.player.destroy();
}
}
  logout() {

    // this.router.navigate(['/account/login']);
    localStorage.clear();
  //     localStorage.removeItem("clpUser");
  // localStorage.removeItem("token");
  // localStorage.removeItem("gdpr_seen_banner");

     this.router.navigate(['/account/login']).then(() => {
    window.location.reload();
  });
  }
  dashboard() {
    this.user = JSON.parse(localStorage.getItem('clpUser')).type
    if (this.user == 1) {
      this.router.navigate(['/buyer/marketplace']);
    } else {
      this.router.navigate(['/seller/contentlist']);
    }

  }
  gotoScroll(itemId:string){
    this.viewportScroller.scrollToAnchor(itemId);
  }
}
